export type SocialType = {
  title: string;
  image?: string;
  description: string;
}

export const Socials: SocialType[] = [
  {
    title: "social.socials.0.title",
    image: "/images/social/tower.png",
    description: "social.socials.0.description",
  },
  {
    title: "social.socials.1.title",
    description: "social.socials.1.description",
  },
  {
    title: "social.socials.2.title",
    image: "/images/social/moydodyr.png",
    description: "social.socials.2.description",
  },
]